import { foodImage } from "@/assets";

const Template3 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Royel Tanduri");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "No provide"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "No provide"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryDate = previewData?.expiryDate || (isStrictPreview ? "No provide" : "12/05/2026");
  const templateNote =
    previewData?.templateNote ||
    previewData?.template_note ||
    (previewData?.message && previewData.message !== title ? previewData.message : null);
  const voucherItems = previewData
    ? (previewData.voucherItems || [])
    : (isStrictPreview ? [] : [{ menu_item: { name: "Coca-Cola" }, variant: { name: "Medium" } }]);

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="voucher-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>

        <div className="absolute inset-y-0 left-0 w-full bg-white/40 backdrop-blur-[1px] z-10"></div>

        <div className="relative z-20 w-full flex flex-col justify-between p-10 text-black">
          <div className="text-left">
            <h1 className="text-4xl font-black text-[#7A4108] uppercase tracking-tight leading-none mb-1">
              {title}
            </h1>
            <p className="text-xl font-serif italic text-black ml-1">
              {customerName}
            </p>
            <p className="text-lg font-medium text-black mt-1 ml-1">
              Code: {code}
            </p>
            {templateNote ? (
              <p className="text-base font-medium italic text-black mt-1 ml-1">
                &quot;{templateNote}&quot;
              </p>
            ) : null}
          </div>
          {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
            (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
            conjunctionText ||
            (expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide") ||
            (voucherItems && voucherItems.length > 0)) && (
            <div className="text-left mt-auto">
              <div className="text-[11px] leading-tight text-black font-medium">
                <p className="mb-1 uppercase tracking-tight">
                  -Terms & Conditions-
                </p>
                <ul className="list-disc list-inside space-y-0.5 ml-1">
                  {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <li>{paymentText}</li>}
                  {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <li>{orderTypeText}</li>}
                  {conjunctionText && <li>{conjunctionText}</li>}
                  {expiryDate && expiryDate !== "N/A" && expiryDate !== "Not provided" && expiryDate !== "No provide" && <li>Exp. Date: {expiryDate}</li>}
                  {voucherItems.map((item, index) => (
                    <li key={index}>
                      Item: {item?.menu_item?.name || item?.name || ""}
                      {item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : ""}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Template3;
